import { styled } from "@/styles/stitches.config";

export const StitchesBox = styled('div');
